import { api } from '@/lib/api'
import { defaultPaginationMeta, parseMasterCatalogResponse } from '@/lib/api/masterCatalog'

/** @typedef {import('@/types/api').TaxProfile} TaxProfile */

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<{ items: TaxProfile[], meta: import('@/types/api').PaginationMeta }>}
 */
export async function fetchTaxProfilesPage(params = {}) {
  const { data } = await api.get('/masters/tax-profiles', { params })
  const parsed = parseMasterCatalogResponse(data, 'tax_profiles')
  return {
    items: parsed.items,
    meta: defaultPaginationMeta(parsed.meta ?? {}),
  }
}

/**
 * @param {Record<string, unknown>} [params]
 * @returns {Promise<TaxProfile[]>}
 */
export async function fetchTaxProfilesList(params = {}) {
  const { data } = await api.get('/masters/tax-profiles', { params })
  return data.data.tax_profiles
}

/**
 * @returns {Promise<TaxProfile[]>}
 */
export async function fetchTaxProfiles() {
  return fetchTaxProfilesList()
}

/**
 * @param {Partial<TaxProfile>} payload
 * @returns {Promise<TaxProfile>}
 */
export async function createTaxProfile(payload) {
  const { data } = await api.post('/masters/tax-profiles', payload)
  return data.data.tax_profile
}

/**
 * @param {number} taxProfileId
 * @param {Partial<TaxProfile>} payload
 * @returns {Promise<TaxProfile>}
 */
export async function updateTaxProfile(taxProfileId, payload) {
  const { data } = await api.put(`/masters/tax-profiles/${taxProfileId}`, payload)
  return data.data.tax_profile
}
